import { useState } from 'react';
import { css } from '@emotion/react';
import { createFileRoute } from '@tanstack/react-router';
import { PasswordResetOIDC, SignInError, Layout } from '../components';

export interface ResetPasswordParams {
  username?: string;
  errorCode?: string;
}

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): ResetPasswordParams => {
    return {
      username: (search.username as string) || undefined,
      errorCode: (search.errorCode as string) || undefined,
    };
  },
  component: ResetPassword,
});

function ResetPassword() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const [isError, setIsError] = useState(!!search.errorCode);

  return (
    <Layout background={'green'}>
      <PasswordResetOIDC
        initialUsername={search.username ?? ''}
        onBack={(username) => {
          return navigate({
            to: '/',
            search: {
              username: username ?? '',
            },
          });
        }}
      />
      <div
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin: 0 15%;
          min-width: 300px;
          max-width: 400px;
        `}
      >
        {isError ? <SignInError errorCode={search.errorCode ?? ''} onErrorHide={setIsError} /> : null}
      </div>
    </Layout>
  );
}
